// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Controller, Thumbs, Autoplay, FreeMode, Lazy } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/controller';
import 'swiper/css/thumbs';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';


Swiper.use([Navigation, Pagination, Controller, Thumbs, Autoplay, FreeMode, Lazy])
window.swiper = Swiper
